




































































import {Component, Prop, Vue} from "vue-property-decorator";
import VueError from "@/components/VueError.vue";
import TimestampAgo from "@/components/TimestampAgo.vue";
import tippy from "tippy.js";
import {NTag} from "@/types/ntag";

@Component({
  components:{
    VueError,
    TimestampAgo,
  }
})
export default class NtagTagRow extends Vue {
  error:string = '';
  @Prop({ default: {},  type: Object}) tag!: NTag;

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;
  @Prop({ default: 'tagId',  type: String}) orderBy!: 'tagId'|'lastOnline'|'locationId';
  @Prop({ default: 'asc',  type: String}) ascDesc!: 'asc'|'desc';

  mounted() {
    tippy('[data-tippy-content]');
  }

  toggleOrder(newOrderBy:'tagId'|'lastOnline'|'locationId'|'enterpriseId'|'sku') {

    // we are clicking on what we are ordering by already
    if(this.orderBy === newOrderBy)
      return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: this.ascDesc === 'asc' ? 'desc' : 'asc'});

    // we are clicking on another column -> we default to asc
    switch(newOrderBy) {
      case 'tagId':
      case 'enterpriseId':
      case 'locationId':
      case 'sku':
        return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: 'asc'});
      case 'lastOnline':
        return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: 'desc'});
    }

  }

  get renderEnterprise(): string {
    return this.tag.enterpriseId ? `${this.tag.enterpriseId.replace(/^nnn\./, '')}` : 'not defined';
  }

  get renderLocation(): string {
    return this.tag.location ? `${this.tag.location.name}` : 'N/A';
  }

  get renderBatteryVoltage(): string {
    return this.tag.batteryVol ? `${this.tag.batteryVol} mV` : '-';
  }

  get renderTemperature(): string {
    return this.tag.temperature ? `${this.tag.temperature}°` : '-';
  }

  goToTagPage(tagId:string) {
    this.$router.push(`/applications/ntag/tags/${tagId}`);
  }
}
